import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const listNotifications = async ({ page = 0, size = 20, unreadOnly = false, type } = {}) => {
  const params = { page, size, unreadOnly };
  if (type) {
    params.type = type;
  }
  const envelope = await requestCallCenter({
    method: "get",
    url: "notifications",
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load notifications");
};

export const getNotificationUnreadCount = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "notifications/unread-count",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load notification count");
};

export const markNotificationRead = async (id) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: `notifications/${id}/read`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to mark notification as read");
};

export const markAllNotificationsRead = async ({ type } = {}) => {
  const params = {};
  if (type) {
    params.type = type;
  }
  const envelope = await requestCallCenter({
    method: "patch",
    url: "notifications/read-all",
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to mark all notifications as read");
};
